import { useSelector } from "react-redux";
import toPriceDisplay from "../utils/toPriceDisplay";
import useGoTo from "../hooks/useGoTo";
import { selectLayout } from "../ducks/shopSelectors";
import useCartSummary from "../hooks/useCartSummary";

/**
 * Barra da sacola, em todos os modos: branca, presa embaixo, com o total e a
 * contagem de itens à esquerda e o botão Ver sacola à direita (como no
 * iFood). No totem e no tablet ela fica sob a coluna de produtos e maior
 * (`cart-summary-bar--totem`, em src/styles/totem.css).
 */
export default function FloatingCartSummary() {
  const goTo = useGoTo();
  const layout = useSelector(selectLayout);
  const inLocoText = useSelector((state) => state.shop.inLocoText);
  const { itemsCount, total } = useCartSummary();

  const label = inLocoText ? `Ver sacola (${inLocoText})` : "Ver sacola";
  const isTotem = layout.cart === "totem";

  return (
    <div
      className={`cart-summary-bar fixed-bottom${
        isTotem ? " cart-summary-bar--totem" : ""
      }`}
    >
      <p className="cart-summary-bar__total">
        <strong>{toPriceDisplay(total)}</strong>
        <span className="cart-summary-bar__count">
          {" "}
          / {itemsCount === 1 ? "1 item" : `${itemsCount} itens`}
        </span>
      </p>
      <button
        type="button"
        className="btn btn-shop cart-summary-bar__button"
        onClick={() => goTo("/checkout")}
      >
        {label}
      </button>
    </div>
  );
}
